import styled from "styled-components";

export const UploadBoxWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 0 24px;
    background-color: var(--white);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
    border-radius: 10px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    .uploadPost{
        display: flex;
        width: 100%;
        padding: 16px 0;
        gap: 16px;
        border-bottom: 1px solid var(--border);
        align-items: center;
        img{
            min-width: 48px;
            max-width: 48px;
            height: 48px;
        }
        .formEleContainer{
            margin-top: 0;
            margin-bottom: 0;
        }
        

    }
`
export const UploadActionBtnWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 16px 0;
    gap: 12px;
    align-items: center;
    @media (max-width: 1270px) {
        &{
            gap: 5px;
            button{
                padding: 4px 7px;
            }
        }

    }
    @media (max-width: 850px) {
        &{
            flex-wrap: wrap;
        }

    }
`